<div class="pagination-container w-100" [style.background]="backgroundColor?backgroundColor:'#fff'">
    <ul class="pagination mt-2 pb-2 cursor">
        <li [ngClass]="{'pagination-disable':pagination?.currentPage === 1}" class="page-item first-item">
            <a (click)="onPaginateChange(1)" class="page-link" data-toggle="tooltip" title="First"><em
                    class="fas fa-angle-double-left"></em></a>
        </li>
        <li [ngClass]="{'pagination-disable':pagination?.currentPage === 1}" class="page-item previous-item">
            <a (click)="onPaginateChange(pagination?.currentPage - 1)" class="page-link" data-toggle="tooltip"
                title="Previous"><em class="fas fa-angle-left"></em></a>
        </li>
        <li *ngFor="let page of pagination?.pages" [ngClass]="{active:pagination?.currentPage === page}"
            class="page-item number-item">
            <a (click)="onPaginateChange(page)" class="page-link">{{page}}</a>
        </li>
        <li [ngClass]="{'pagination-disable':pagination?.endPage}" class="page-item next-item">
            <a (click)="onPaginateChange(pagination?.currentPage + 1)" class="page-link" data-toggle="tooltip"
                title="Next"><em class="fas fa-angle-right"></em></a>
        </li>
        <li [ngClass]="{'pagination-disable':pagination?.endPage}" class="page-item last-item">
            <a (click)="onPaginateChange(pagination?.endPageNumber)" class="page-link" data-toggle="tooltip"
                title="Last"><em class="fas fa-angle-double-right"></em></a>
        </li>
    </ul>
</div>